import React from 'react';
import TwBadge from './../TwBadge/TwBadge';

import { ORDER_STATUS, OrderStatusColor } from '../../redux/api/orders/orders.model';
import StringUtils from '../../utils/stringUtils';

export interface TwLoadStatusProps {
  loadStatus: ORDER_STATUS;
  /**
   * Dark status is used to show the status with colored background and white label
   * (default is false)
   */
  darkStatus?: boolean;
}

const TwLoadStatus: React.FC<TwLoadStatusProps> = ({ loadStatus, darkStatus }): JSX.Element => {
  const title = StringUtils.getOrderStatusLabel(loadStatus).toLocaleLowerCase();
  return (
    <TwBadge
      content={title}
      sx={{
        color: darkStatus ? `white !important` : `${OrderStatusColor[loadStatus]} !important`,
        backgroundColor: darkStatus
          ? `${OrderStatusColor[loadStatus]} !important`
          : `${OrderStatusColor[loadStatus]}20 !important`
      }}
      className="tid-load-status"
    />
  );
};
export default TwLoadStatus;
